module.exports = __webpack_public_path__ + "img/visualization-side-bar-button.ed4ef7d7.svg";